import { render, staticRenderFns } from "./AAuditItemNoteDialog.vue?vue&type=template&id=356523fa&"
import script from "./AAuditItemNoteDialog.vue?vue&type=script&lang=ts&"
export * from "./AAuditItemNoteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports